'use strict';

require('../scss/common.scss');

import $ from 'jquery';

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';

import videogular from 'videogular';
import videogularControlls from 'videogular-controls';
import videogularBuffering from 'videogular-buffering';
import videogularOverlayPlay from 'videogular-overlay-play';
import videogularThemesDefault from 'videogular-themes-default';

import angularUtilsPagination from 'angular-utils-pagination';

import infiniteScroll from 'ng-infinite-scroll';

import {core} from 'site_core';

// Our Modules
import appRoutes from './app.routes';
import appRun from './app.run';
import appDirectives from './app.directive.config.js';

'ngInject';
var app = angular.module('site', [
  angularUtilsPagination,
  uiRouter,
  ngCookies,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll
]);

app.config(['$provide', appDirectives]);
app.config(appRoutes);
app.run(appRun);

app.constant('BASE_URLS', {API: API_URL, CONTENT: CONTENT_URL});

app.constant('siteConst', {
	id: 19,
  urlShort: 'FetishFlixx.com',
  urlLong: 'http://www.fetishflixx.com',
  urlMed: 'www.fetishflixx.com',
  name: 'Fetish Flixx',
  currentDate: Date.now(),
  footerTagline: '',
  logoLarge: 'images/fetish_flixx.logo.png',
  logoSmall: 'images/fetish_flixx.log.png',
  freeBanner: 'images/ff_header.png',
  memberImage: '',
  twoTwoFiveSevenAddress: '5400 W. 64th Ave Arvada, CO 80007',
  webmasterEmail: 'fetishflixx@spanking.support',
  metaDescription: '',
  tagline: {
    topLine: '',
    secondLine: ''
  },
  footerTagline: {
    bannerDetails: '',
    getPassword: '<div class="get_password"><h4 ng-hide="$root.isMember"><a href="/join">Welcome To FetishFlixx.com</a></h4> </p>The Premier Site Dedicated Totally To Fetish UK Spankings and Punishments! We have taken the very best Fetish UK movies ever produced in the past 10 years and have started to add them online here for you to download & enjoy! Tons of Videos Starring Elizabeth Simpson and Rosaleen Young. Happy Spanking Missy xXx</p></div>'
  },
  advert: {
    slider: {
      image: 'images/ff_header.png'
    },
    tour: [
      'Welcome to Fetish Flixx!',
      'Fetish UK Spanking Videos & Pics',
      'F/F and M/F Fetish Spankings',
      'Full Updates Every Week',
      'Unlimited Streaming and Downloads',
      'Mobile and Tablet Ready'
    ],
    trailer: [
      'F/F and M/F Spanking Videos',
      'Huge collection of Spanking Vids',
      'Full Updates Every Week',
      'Unlimited Streaming and Downloads',
      'Mobile and Tablet Ready',
      'Classic UK Discipline',
      'Rosaleen Young Collection',
      'Strappings and OTK Hand Spankings'
    ]
  },
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  join: {
    ccbill: {
      key: 'bd1010d5-ee34-4475-9ad7-32d6173efca2'
    },
    cco: {
      accountId: 9309,
      siteId: 23695,
      products: [
        {
          price: 79.95,
          text: '<div class="details"> <div class="duration">6 Months Access</div> <div class="description">Only 79.95 for 6 months *** No Rebills ***</div> </div> <div class="discount">Save 125%!</div> <div class="price">$13.33 / month</div>',
          productId: 42130
        },
        {
          price: 59.95,
          text: '<div class="details"> <div class="duration">3 Months Access</div> <div class="description">Only 59.95 for 3 months</div> </div> <div class="discount">Save 50%!</div> <div class="price">$19.98 / month</div>',
          productId: 42130
        },
        {
          price: 29.95,
          text: '<div class="details"> <div class="duration">30 Day Access</div> <div class="description">Only 29.95 for 30 days</div> </div> <div class="discount">Save 0%!</div> <div class="price">$0.99 / day</div>',
          productId: 42130
        }
      ]
    }
  },
  members: {
    video: {
      labels: true
    },
    images: {
      showImages: true
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js